import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as authActions from './../Auth/authActions'; 

import Aux from './../../hoc/_Aux';

import { generateInputControls, onChangedHandler, generateForm } from './../../utils/form/generateFormTools';

class LoginForm extends Component {

    // defines inputs that belongs to the current form 
    elementsForForm = {
        username:{
            labelPosition: 'right',
            placeholder: 'Ton super pseudo',
            defaultValue: '' 
        },
        link_username:{
            text: 'Aïe ! j\'ai oublié mon pseudo',
            destination: '/forgotten-username'
        },
        password: {
            labelPosition: 'left',
            placeholder: 'Ton mot de passe top secret',
            defaultValue: ''  
        },
        link:{
          text: 'OUPS ! j\'ai oublié mon mot de passe',
          destination: '/reset-password'
        },
        submit: {
            defaultValue: 'Je valide' //submit needs value instead of label
        }
    };

    state = {
        controls: generateInputControls(['username','link_username', 'password', 'link', 'submit'], this.elementsForForm)
    }

    // routine legacy from generateFormTools.js
    inputChangedHandler = onChangedHandler;
    

    submitHandler = ( event ) => {
        event.preventDefault();
        const {onAuth, onAuthError} = this.props;

        const errorValue = (this.state.controls.username.value?0:10) + (this.state.controls.password.value?0:1);

        switch(errorValue)
        {
            case 0: //both fields are filled
                onAuth( this.state.controls.username.value, this.state.controls.password.value );
                break;
            case 1: //password is empty
                onAuthError('', 'auth/empty-password'); //error message are in the messageDictionary
                break;
            case 10: //username is empty
                onAuthError('', 'auth/empty-user'); //error message are in the messageDictionary
                break;
            case 11: //both username and password are empty
                onAuthError('', 'auth/empty-user-and-password'); //error message are in the messageDictionary
                break;
            default: //impossible 
                break;
        }

    }

    render(){
        // const { hasError, errorMessage } = this.props;
        let form = generateForm(this, this.state.controls);
        return (
            <Aux>
                <form onSubmit={this.submitHandler} name={this.props.name} className={this.props.class}>
                    {form}
                </form>
            </Aux>
        );
    }
}

const mapStateToProps = state => {
    return {
        hasError: state.auth.hasError,
        errorMessage: state.auth.errorMessage
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAuth: ( username, password ) => dispatch( authActions.login( username, password ) ),
        onAuthError: (errorCode, errorMessage) => dispatch( authActions.loginError(errorCode, errorMessage))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )(LoginForm);


// WEBPACK FOOTER //
// ./src/components/forms/loginForm.js